import find from 'lodash/find';

import urlConfigs from 'services/apiConfigs';

const formatParam = (param) => {
  return param
    .replace(/%/g, '%25')
    .replace(/ /g, '%20')
    .replace(/\$/g, '%24')
    .replace(/#/g, '%23');
};

export default {
  getLiveDiscussionMagicLink(state, getters) {
    const { getCurrentDiscussion } = getters;
    let urlBase = `${urlConfigs.uiURL}/classes/${getCurrentDiscussion.course_id}/roundtables`;
    urlBase += `/live/${getCurrentDiscussion.id}?invite_code=`;

    const invite_code = getCurrentDiscussion.invites
      ? getCurrentDiscussion.invites[0].code
      : '';
    return `${urlBase}${formatParam(invite_code)}`;
  },
  getCurrentDiscussion(state) {
    return state.currentDiscussion;
  },
  getClassSummaryLD(state) {
    return state.grades.classSummary;
  },
  getStudentSummaryLD(state) {
    return state.grades.studentSummary;
  },
  getLoadingStudentSummaryLD(state) {
    return state.grades.loading;
  },
  getStudentAssessmentsLD(state) {
    return state.grades.studentSummary.points_settings.peer_rewards.map(
      (pr) => {
        const currentAssessment = state.grades.studentSummary.assessments.find(
          (a) => a.tag === pr.tag
        );
        return {
          tag: pr.tag,
          value: currentAssessment ? currentAssessment.value : 0,
          title: pr.title,
        };
      }
    );
  },
  getLoadingLD(state) {
    return state.loading;
  },
  isUnsavedTeacherFeedback(state) {
    return state.unsaved_teacher_feedback;
  },

  getQueue(state, getters) {
    const queue = JSON.parse(JSON.stringify(state.currentDiscussion.queue));

    const queue_with_names = queue.map((queued_student) => {
      const student_in_course = find(
        getters.getStudentsInCourse,
        (student) => student.id === queued_student.user_id
      );
      queued_student.name = student_in_course ? student_in_course.name : '';
      return queued_student;
    });

    return queue_with_names;
  },
  getQueueHistory(state) {
    return state.currentDiscussion.queue_history;
  },
  // END TODO

  // NOTE: Currently only used for agrees and disagrees
  // REMOVE when we no longer use turns for agreein and disagreeing in favour of polling
  // Reads from current discussion to pick out the current turn
  getCurrentTurn(state, getters) {
    const { current_turn_id } = getters.getCurrentDiscussion;
    return { id: current_turn_id };
  },
  getMyParticipation(state, getters) {
    return (
      find(
        getters.getCurrentDiscussion.participations,
        (participation) => participation.user_id === getters.getProfile.id
      ) || { id: null, notes: {} }
    );
  },
  // isLiveDiscussionBetaTester(state, { getCourseDetail }) {
  isLiveDiscussionBetaTester() {
    return true;
    // const teachers_that_have_access_to_mvp = [
    //   '7almartin@gmail.com',
    //   'ben@parlayideas.com',
    //   'bobby@parlayideas.com',
    //   'bobby+teacher@parlayideas.com',
    //   'heather@parlayideas.com',
    //   'jeff.whittard@hsc.on.ca',
    //   'fenstermaker.andrew@iowacityschools.org',
    //   'shedgcock@sarasotachristian.org',
    //   'marc.brims@utschools.ca',
    //   'sberezowsky@ucc.on.ca',
    //   'tcollins@ebrschools.org',
    //   'nwarn@miltonps.org',
    //   'nicholas.day@sac.on.ca',
    //   'josh.bateson@dsbn.org',
    //   'whittaje@hsc.on.ca',
    //   'rbrady@johncooper.org',
    //   'alexiswiggins@gmail.com',
    //   'smastromonaco@villanovacollege.ca',
    //   'jennifer.weening@gx.cds.on.ca',
    //   'Socrates+test@parlayideas.com',
    //   'lisa@parlayideas.com',
    // ];
    // const selected_teacher_emails = teachers_that_have_access_to_mvp.map((email) => email.toLowerCase());
    // const course_author = getCourseDetail.users.find((user) => {
    //   return user.subscription.role === 'author';
    // });
    // return (
    //   course_author &&
    //   course_author.email &&
    //   (selected_teacher_emails.includes(course_author.email.toLowerCase()))
    // );
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/liveDiscussions/getters.js